import React from 'react';
import { Carousel } from '@admitkard/ccl/Carousel';
import { env } from '@admitkard/uiutils/env';
import { careerCss } from 'components/Career/Career.css';

interface NewsCard {
  newsContent: string,
  cardImgUrl: string,
  blogImgUrl: string,
  blogUrl: string,
}

const NewsCard: React.FunctionComponent<NewsCard> = (props) => {
  return (
    <>
      <div className='news-card'>
        <div>
          <img src={env.getAssetUrl(props.cardImgUrl)} alt='...' />
        </div>
        <div className='news-card-content'>
          {`${props.newsContent}`}
        </div>
        <div className='flex-justify-content'>
          <div className='card-footer-img'>
            <img src={env.getAssetUrl(props.blogImgUrl)} />
          </div>
          <a href={props.blogUrl} target='_blank' rel="noreferrer">
            View More
          </a>
        </div>
      </div>
      <style jsx>{careerCss}</style>
    </>
  );
};

const News: React.FunctionComponent = () => {
  return (
    <>
      <div className='news-wrapper'>
        <div className='news-heading font-f'>News and funding</div>
        <div className='news-carousel-wrapper'>
          {/* web */}
          <div className='news-carousel-web'>
            <Carousel
              arrows="none"
              dots="outside"
              name="carouselWeb"
              peek={{
                after: 0,
                before: 0
              }}
              slidePerView={3}
              slides={[
                <NewsCard
                  key={3}
                  newsContent='Admitkard selected in Top-20 of GSV cup, the world largest pitch competition for Ed-tech Startup'
                  cardImgUrl='images/career-page/card_image_1.png'
                  blogImgUrl='images/career-page/media_blog_image_1.png'
                  blogUrl='https://www.indianweb2.com/2022/03/admitkard-selected-in-top-20-of-gsv-cup.html?m=1'
                />,
                <NewsCard
                  key={4}
                  newsContent='Raised $1 million in pre-Series A round led by Australian EdTech fund Growth DNA,
                  followed by appearing again in “Entrackr” and raising $3.3 million in a fresh round.'
                  cardImgUrl='images/career-page/card_image_2.png'
                  blogImgUrl='images/career-page/media_blog_image_1.png'
                  blogUrl='https://www.indianweb2.com/2019/09/noida-based-startup-admitkard-raises-1.html'
                />,
                <NewsCard
                  key={1}
                  // eslint-disable-next-line spellcheck/spell-checker
                  newsContent='AdmitKard, the startup for college admissions has raised Rs 50 crore ($6 million) in Series A funding,
                  led by international edtech investor GSV Ventures.'
                  cardImgUrl='images/career-page/card_image_5.png'
                  blogImgUrl='images/career-page/media_blog_image_5.png'
                  blogUrl='https://startup.siliconindia.com/startup-funding/admitkard-raises-rs-50-cr-in-series-a-nwid-37297.html'
                />,
                <NewsCard
                  key={2}
                  // eslint-disable-next-line spellcheck/spell-checker
                  newsContent='College admissions startup AdmitKard has raised Rs 50 crore ($6 million) in Series A funding,
                  led by global edtech investor firm GSV Ventures, a top executive told VCCircle.'
                  cardImgUrl='images/career-page/card_image_6.webp'
                  blogImgUrl='images/career-page/media_blog_image_6.svg'
                  blogUrl='https://www.vccircle.com/admitkardraises-rs-50-cr-in-series-a'
                />,
                <NewsCard
                  key={5}
                  cardImgUrl='images/career-page/card_image_3.png'
                  newsContent='In May 2022, we made it to the “Financial Express” for expansion of our services upto the MiddleEast,
                    Nepal, Bangladesh and Nigeria, and making our student base stronger by 10 times.'
                  blogImgUrl='images/career-page/media_blog_image_3.png'
                  // eslint-disable-next-line max-len
                  blogUrl={`https://www.financialexpress.com/education-2/admitkard-banks-on-expansion-in-middleeast-nepal-bangladesh-and-nigeria-aims-to-grow-students-base-by-10-times/2507181/`}
                />,
                <NewsCard
                  key={6}
                  newsContent='We increased our talent pool by 66% in the recent 4 months and look forward to growing more.'
                  cardImgUrl='images/career-page/card_image_4.png'
                  blogImgUrl='images/career-page/media_blog_image_1.png'
                  blogUrl={`https://www.indianweb2.com/2022/05/edtech-startup-admitkard-to-increase.html`}
                />
              ]}
              type="carousel"
            />
          </div>
          {/* mobile */}
          <div className='news-carousel-mobile'>
            <Carousel
              arrows="none"
              dots="outside"
              name="carouselMobile"
              peek={{
                after: 0,
                before: 0
              }}
              slidePerView={1}
              slides={[
                <NewsCard
                  key={1}
                  // eslint-disable-next-line spellcheck/spell-checker
                  newsContent='AdmitKard, the startup for college admissions has raised Rs 50 crore ($6 million) in Series A funding,
                  led by international edtech investor GSV Ventures.'
                  cardImgUrl='images/career-page/card_image_5.png'
                  blogImgUrl='images/career-page/media_blog_image_5.png'
                  blogUrl='https://startup.siliconindia.com/startup-funding/admitkard-raises-rs-50-cr-in-series-a-nwid-37297.html'
                />,
                <NewsCard
                  key={2}
                  // eslint-disable-next-line spellcheck/spell-checker
                  newsContent='College admissions startup AdmitKard has raised Rs 50 crore ($6 million) in Series A funding,
                  led by global edtech investor firm GSV Ventures, a top executive told VCCircle.'
                  cardImgUrl='images/career-page/card_image_6.webp'
                  blogImgUrl='images/career-page/media_blog_image_6.svg'
                  blogUrl='https://www.vccircle.com/admitkardraises-rs-50-cr-in-series-a'
                />,
                <NewsCard
                  key={3}
                  newsContent='Admitkard selected in Top-20 of GSV cup, the world largest pitch competition for Ed-tech Startup'
                  cardImgUrl='images/career-page/card_image_1.png'
                  blogImgUrl='images/career-page/media_blog_image_1.png'
                  blogUrl='https://www.indianweb2.com/2022/03/admitkard-selected-in-top-20-of-gsv-cup.html?m=1'
                />,
                <NewsCard
                  key={4}
                  newsContent='Raised $1 million in pre-Series A round led by Australian EdTech fund Growth DNA,
                  followed by appearing again in “Entrackr” and raising $3.3 million in a fresh round.'
                  cardImgUrl='images/career-page/card_image_2.png'
                  blogImgUrl='images/career-page/media_blog_image_1.png'
                  blogUrl='https://www.indianweb2.com/2019/09/noida-based-startup-admitkard-raises-1.html'
                />,
                <NewsCard
                  key={5}
                  cardImgUrl='images/career-page/card_image_3.png'
                  newsContent='In May 2022, we made it to the “Financial Express” for expansion of our services upto the MiddleEast,
                    Nepal, Bangladesh and Nigeria, and making our student base stronger by 10 times.'
                  blogImgUrl='images/career-page/media_blog_image_3.png'
                  // eslint-disable-next-line max-len
                  blogUrl={`https://www.financialexpress.com/education-2/admitkard-banks-on-expansion-in-middleeast-nepal-bangladesh-and-nigeria-aims-to-grow-students-base-by-10-times/2507181/`}
                />,
                <NewsCard
                  key={6}
                  newsContent='We increased our talent pool by 66% in the recent 4 months and look forward to growing more.'
                  cardImgUrl='images/career-page/card_image_4.png'
                  blogImgUrl='images/career-page/media_blog_image_1.png'
                  blogUrl={`https://www.indianweb2.com/2022/05/edtech-startup-admitkard-to-increase.html`}
                />
              ]}
              type="carousel"
            />
          </div>
        </div>
      </div>
      <style jsx>{careerCss}</style>
    </>
  );
};

export {News};
